import { combineReducers } from 'redux';
import appDataSlice from './appData';
import { createReducerList } from './common';
import dialogSlice from './dialog';
import docInfoSlice from './docInfo';
import popupSlice from './popup';
import replaceEmptyAdSlice from './replaceEmptyAd';
import toastSlice from './toast';
import confirmSlice from './confirm';
import appLoadingSlice from './appLoading';
import notificationSlice from './notification';
import extensionHandleSlice from './extensionHandle';
import whaleSpaceDataSlice from './whaleSpaceData';
import naverWorksDataSlice from './naverWorksData';
import contextMenuSlice from './contextMenu';
import pwcAuthDataSlice from './pwcAuthData';
import naverWorksPopupDataSlice from './naverWorksPopupData';
import whiteListSlice from './whiteList';

//추가되는 slice 는 아래 배열에 넣어만 주세요 !!
const sliceList = [
  dialogSlice,
  docInfoSlice,
  toastSlice,
  appDataSlice,
  popupSlice,
  replaceEmptyAdSlice,
  confirmSlice,
  appLoadingSlice,
  notificationSlice,
  extensionHandleSlice,
  whaleSpaceDataSlice,
  naverWorksDataSlice,
  contextMenuSlice,
  pwcAuthDataSlice,
  naverWorksPopupDataSlice,
  whiteListSlice
];

const rootReducer = combineReducers(createReducerList(sliceList));

export default rootReducer;
